module.exports = __webpack_public_path__ + "static/img/portfolio_bg2.07c5c22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_bg-portfolio/portfolio_bg2.png
// module id = RpIy
// module chunks = 1